import {
  __,
  pipe,
  reduce,
  filter,
  pluck,
  prop,
  propEq,
  sum,
  includes,
  not,
  any,
} from "ramda";
import {
  useGiftCards,
  giftCards,
  useVouchers,
  vouchers,
} from "ticketbuyer/order/store";
import { show as showNotification } from "common/notifications/Notifications";

const itemActualPrice = pipe(prop("actual_price"), parseFloat);

function actualPriceForCreditCardAndGiftCard(items) {
  return reduce(
    (acc, item) => {
      if (item.requires_click_card) {
        acc.clickCardDependentItemsPrice += itemActualPrice(item);
      } else {
        acc.regularItemsPrice += itemActualPrice(item);
      }

      return acc;
    },
    {
      regularItemsPrice: 0,
      clickCardDependentItemsPrice: 0,
    },
    items
  );
}

angular
  .module("ticketco/ticketbuyer/gift_cards")
  .component("ticketbuyerGiftCards", {
    templateUrl: "ticketbuyerGiftCardsComponent.html",
    bindings: {
      orderUuid: "@",
      newGiftCard: "@",
      // actualPrice: "@",
      balanceItems: "<",
      onChange: "&",
      items: "<",
    },
    controller: function (
      $q,
      BalanceItemsPersistence,
      tcDialogWrapper,
      GiftCardsDialogs
    ) {
      var self = this;

      self.actualPrice = 0;

      var mapCardsBalance = function (actualPrice, cards) {
        var sum = actualPrice;
        return cards.map(function (card) {
          var newCard = Object.assign({}, card);
          newCard.use = Math.min(sum, parseFloat(card.balance));
          sum = parseFloat((sum - newCard.use).toFixed(2));
          newCard.remaining = parseFloat(
            (newCard.balance - newCard.use).toFixed(2)
          );
          return newCard;
        });
      };

      var prevalidateGiftCard = function (obj) {
        if (!any(propEq("ref_number", obj.ref_number), self.balanceItems)) {
          return $q.resolve(obj);
        } else {
          return $q.reject(["Gift card already added"]);
        }
      };

      var postvalidateGiftCard = function (card) {
        if (propEq("balance", 0, card)) {
          return $q.reject(["Gift card has zero balance"]);
        }
        if (propEq("covers_item_type_ids", 0, card)) {
          return $q.reject(["Gift card has zero balance"]);
        }
        return $q.resolve(card);
      };

      function giftCardsNotify(balanceItems) {
        self.onChange({
          $giftCards: balanceItems,
          $giftCardUuidsString: pluck("uuid", balanceItems).join(","),
        });
      }

      function giftCardsDomNotify(balanceItems) {
        $("body").trigger({
          type: "tc-gift-cards-changed",
          giftCards: balanceItems,
        });
        const giftCardItems = self.balanceItems.filter(
          propEq("type", "GiftCardType")
        );
        const voucherItems = self.balanceItems.filter(
          propEq("type", "VoucherType")
        );
        giftCards.set(giftCardItems);
        useGiftCards.set(giftCardItems.length > 0);

        vouchers.set(voucherItems);
        useVouchers.set(voucherItems.length > 0);
      }

      self.$onInit = function () {
        self.newGiftCard = self.newGiftCard || "";
        self.balanceItems = self.balanceItems || [];
        const { clickCardDependentItemsPrice, regularItemsPrice } =
          actualPriceForCreditCardAndGiftCard(self.items);
        self.actualPrice = clickCardDependentItemsPrice + regularItemsPrice;
        self.clickCardDependentItemsPrice = clickCardDependentItemsPrice;
        self.regularItemsPrice = regularItemsPrice;

        self.balanceItems = mapCardsBalance(
          self.regularItemsPrice,
          self.balanceItems
        );
        giftCardsNotify(self.balanceItems);
        giftCardsDomNotify(self.balanceItems);
      };

      // giftCardsTotal -> Array -> Number
      self.giftCardsTotal = pipe(
        filter(propEq("type", "GiftCardType")),
        pluck("balance"),
        sum
      );
      // vouchersTotal -> Array -> Number
      self.vouchersTotal = pipe(
        filter(propEq("type", "VoucherType")),
        pluck("balance"),
        sum
      );
      // TODO: Implement correct calc
      self.clickCardsTotal = pipe(
        filter(propEq("type", "ClickCardType")),
        pluck("balance"),
        sum
      );

      self.balanceItemsTotal = pipe(
        filter(
          pipe(
            prop("type"),
            includes(__, ["GiftCardType", "GiftCardType", "ClickCardType"])
          )
        ),
        pluck("balance")
        // ,sum
      );

      self.duePaymentTotal = function (cards) {
        return Math.max(
          parseFloat(
            self.regularItemsPrice -
              self.giftCardsTotal(cards) -
              self.vouchersTotal(cards)
          ),
          0
        ).toFixed(2);
      };

      self.duePaymentByClickCards = function (cards) {
        return Math.max(
          parseFloat(
            self.clickCardDependentItemsPrice - self.clickCardsTotal(cards)
          ),
          0
        ).toFixed(2);
      };

      function showAddGiftCardDialog() {
        return tcDialogWrapper.open(GiftCardsDialogs.addGiftCard);
      }

      function showAddVoucherDialog() {
        return tcDialogWrapper.open(GiftCardsDialogs.addVoucher);
      }

      function handleErrors(res) {
        (res.data?.errors || []).forEach((error, index) => {
          showNotification(error, {
            id: index,
            type: "error",
            title: "Error message",
          });
        });

        return res;
      }

      // Commands
      self.addGiftCardCommand = function (orderUuid) {
        return showAddGiftCardDialog(orderUuid)
          .then(prevalidateGiftCard)
          .then(function (res) {
            return BalanceItemsPersistence.verify({
              order_uuid: self.orderUuid,
              ref_number: res.ref_number,
              token: res.token,
              type: "gift_cards",
            });
          })
          .then(postvalidateGiftCard)
          .then(function (res) {
            self.balanceItems = mapCardsBalance(
              self.actualPrice,
              self.balanceItems.concat({ ...res, type: "GiftCardType" })
            );
            self.newGiftCard = "";
            giftCardsNotify(self.balanceItems);
            giftCardsDomNotify(self.balanceItems);
            return res;
          })
          .catch(handleErrors);
      };

      self.addVoucherCommand = function (orderUuid) {
        return showAddVoucherDialog(orderUuid)
          .then(prevalidateGiftCard)
          .then(function (res) {
            return BalanceItemsPersistence.verify({
              order_uuid: self.orderUuid,
              ref_number: res.ref_number,
              token: res.token,
              type: "vouchers",
            });
          })
          .then(postvalidateGiftCard)
          .then(function (res) {
            self.balanceItems = mapCardsBalance(
              self.actualPrice,
              self.balanceItems.concat({ ...res, type: "VoucherType" })
            );
            self.newGiftCard = "";
            giftCardsNotify(self.balanceItems);
            giftCardsDomNotify(self.balanceItems);

            return res;
          })
          .catch(handleErrors);
      };

      self.removeGiftCardCommand = function (uuid) {
        self.balanceItems = mapCardsBalance(
          self.actualPrice,
          self.balanceItems.filter(pipe(propEq("uuid", uuid), not))
        );
        giftCardsDomNotify(self.balanceItems);
        return self.balanceItems;
      };
    },
  });
